(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory;
    }

    root.SkmHomePageSettingCardSave = factory;
}(typeof globalThis !== 'undefined' ? globalThis : this, function createHomePageSettingCardSave(options) {
    'use strict';

    options = options || {};
    var documentRef = options.document;
    var windowRef = options.window || (documentRef && documentRef.defaultView);
    var fetchRef = options.fetch;
    var FormDataRef = options.FormData;

    function statusElement(form) {
        return form.querySelector('[data-homepage-setting-status]');
    }

    function setStatus(form, message, kind) {
        var target = statusElement(form);
        if (!target) return;
        target.textContent = message || '';
        target.dataset.kind = kind || '';
    }

    function responseMessage(data, fallback) {
        if (data && data.errors) {
            var groups = Object.values(data.errors);
            if (groups.length && groups[0].length) return groups[0][0];
        }
        return data && data.message ? data.message : fallback;
    }

    function notifySuccess(message) {
        if (windowRef && windowRef.skm && typeof windowRef.skm.toast === 'function') {
            windowRef.skm.toast('success', '저장되었습니다', message ? { text: message } : undefined);
        }
    }

    function notifyError(message) {
        if (windowRef && windowRef.skm && typeof windowRef.skm.error === 'function') {
            windowRef.skm.error('저장하지 못했습니다', { text: message });
        }
    }

    function save(form) {
        if (!fetchRef || !FormDataRef || form.dataset.busy === '1') return Promise.resolve(null);
        var button = form.querySelector('button[type="submit"]');
        var originalLabel = button ? button.innerHTML : '';
        form.dataset.busy = '1';
        form.setAttribute('aria-busy', 'true');
        if (button) {
            button.disabled = true;
            button.textContent = '저장 중…';
        }
        setStatus(form, '저장 중…', 'progress');

        return fetchRef(form.action, {
            method: String(form.method || 'POST').toUpperCase(),
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' },
            body: new FormDataRef(form),
        }).then(function (response) {
            return response.json().catch(function () { return {}; }).then(function (data) {
                if (!response.ok) {
                    var error = new Error(responseMessage(data, '잠시 후 다시 시도해주세요.'));
                    error.data = data;
                    throw error;
                }
                return data;
            });
        }).then(function (data) {
            form.querySelectorAll('input[type="file"]').forEach(function (input) { input.value = ''; });
            setStatus(form, '저장됨', 'success');
            notifySuccess(data.message || '저장했습니다.');
            return data;
        }).catch(function (error) {
            var message = error && error.message ? error.message : '잠시 후 다시 시도해주세요.';
            setStatus(form, '저장 실패', 'error');
            notifyError(message);
            return null;
        }).finally(function () {
            form.dataset.busy = '0';
            form.removeAttribute('aria-busy');
            if (button) {
                button.disabled = false;
                button.innerHTML = originalLabel;
            }
        });
    }

    function init() {
        if (!documentRef || !fetchRef || !FormDataRef) return false;
        var forms = Array.from(documentRef.querySelectorAll('[data-homepage-setting-form]'));
        if (!forms.length) return false;

        forms.forEach(function (form) {
            form.addEventListener('input', function () { setStatus(form, '변경됨', 'changed'); });
            form.addEventListener('change', function () { setStatus(form, '변경됨', 'changed'); });
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                save(form);
            });
        });

        return true;
    }

    return { init: init, save: save };
}));
